import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { TripDetails } from "../../../types/api";
import { loadCard } from "../style";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";

interface LoadCardProps {
  tripDetails: TripDetails;
}

const LoadCard: React.FC<LoadCardProps> = ({ tripDetails }) => {
  const { t } = useTranslation();
  const windowWidth = useWindowSize();
  const isMobile = windowWidth < 700;

  return (
    <Card sx={isMobile ? loadCard.cardM : loadCard.cardD}>
      <Typography sx={loadCard.title}>{t("screens.trips.loadCard.load")}</Typography>
      <Box
  sx={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: 2, // Spazio tra gli elementi
  }}
>
  
      <Box>
        <Typography sx={loadCard.subtitle}>
          {t("screens.trips.loadCard.weight")}
           {tripDetails.weightUDM === null ?  "" : "(" + tripDetails.weightUDM + ")" }
        </Typography>
        <Typography sx={loadCard.value}>{tripDetails.weight=== null?  "-" : tripDetails.weight}</Typography>
      </Box>
      <Box>
        <Typography sx={loadCard.subtitle}>
          {t("screens.trips.loadCard.volume")}
          {tripDetails.volumeUDM=== null ? "" : "(" + tripDetails.volumeUDM + ")" }
        </Typography>
        <Typography sx={loadCard.value}>
          {tripDetails.volume=== null ? "-":  tripDetails.volume }
        </Typography>
      </Box>
      <Box>
        <Typography sx={loadCard.subtitle}>
          {t("screens.trips.loadCard.shipUnitCount")}
        </Typography>
        <Typography sx={loadCard.value}>{tripDetails.shipUnitCount}</Typography>
      </Box>
      <Box>
        <Typography sx={loadCard.subtitle}>
          {t("screens.trips.loadCard.linearMeters")}
          {tripDetails.linearMetersUDM === null ? "" :  "(" + tripDetails.linearMetersUDM + ")"}
        </Typography>
        <Typography sx={loadCard.value}>
          {tripDetails.linearMeters === null ?"-": tripDetails.linearMeters }
        </Typography>
      </Box>
      </Box>
    </Card>
  );
};

export default LoadCard;
